<div class="flex-wrapper">
    <div class="head">
        <div class="left-panel">
            <span routerLink="/home" routerLinkActive="active" class="imgcontainer"><img
                    src="assets/images/logo.png"></span>
            <div class="Title">All Projects</div>
        </div>

        <!-- Modified by PP(2022-12-05) : Click twice - START -->
        <!-- <div class="right-panel dropdown">
      <span>
          <fa-icon [icon]="faCog"></fa-icon>
      </span>

      <div class="btn label dropdown-toggle" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" >Settings</div>
      <span class="caret"></span>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <span class="dropdown-item" routerLink="/userInfo" routerLinkActive="active">User Information</span>
        <span class="dropdown-item" routerLink="/progSettings" routerLinkActive="active">Program settings</span>
        <span class="dropdown-item" (click)="logout()"> <fa-icon [icon]="faPowerOff"></fa-icon> Logout</span>
      </div>
    </div> -->

        <div class="nav-item dropdown" style="margin-top:-20px;" ngbDropdown>
            <a class="nav-link dropdown-toggle fontForSettings" id="settingsDropdown" role="button"
                data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle>
                <fa-icon [icon]="faCog"></fa-icon> Settings
            </a>
            <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="navbarScrollingDropdown">
                <li ngbDropdownItem><a class="dropdown-item" routerLink="/userInfo" routerLinkActive="active">User
                        Information</a></li>
                <li ngbDropdownItem><a class="dropdown-item" routerLink="/progSettings"
                        routerLinkActive="active">Program Settings</a></li>
                <li ngbDropdownItem><a class="dropdown-item" (click)="logout()"><fa-icon [icon]="faPowerOff"
                            class="pad10"></fa-icon>Logout</a></li>
            </ul>
        </div>
        <!-- Modified by PP(2022-12-05) : Click twice - END -->

    </div>

    <div class="popupRectangle" (click)="newProject()">
        <span>New Project <span class="icon">
                <fa-icon [icon]="faPlus"></fa-icon>
            </span></span>
    </div>

    <div class="searchArea">
        <div class="searchContainer">
            <span data-toggle="modal" (click)="newFolder()" data-target="#newFolder" class="menubar Exportenabled"><span
                    class="menuIcon">
                    <fa-icon [icon]="faFolderPlus"></fa-icon>
                </span> <span>New Folder</span>
            </span>
            <span data-toggle="modal" data-target="#upload" class="menubar Exportenabled"><span class="menuIcon">
                    <fa-icon [icon]="faFileImport"></fa-icon>
                </span><span>Import Project</span>
            </span>
            <span data-toggle="modal" data-target="#export" class="menubar"
                [ngClass]="fileSelected.length > 0 ? 'Exportenabled': 'ExportDisabled'"><span class="menuIcon">
                    <fa-icon [icon]="faFileExport"></fa-icon>
                </span><span> Export Project</span>
            </span>
            <div>

                <span class="iconSearch">
                    <fa-icon [icon]="faSearch"></fa-icon>
                </span>
                <input type="text" (keyup)="search($event)" class="searchbox" placeholder="Search Projects">
            </div>
        </div>
    </div>

    <div class="subMenu">
        <div class="viewTab">
            <div class="views">
                <span (click)="selectView('Recent')" [ngClass]="viewFlag == 'Recent' ? 'selected': ''"
                    class="tabView stagebtn">Recent</span>
                <span (click)="selectView('All')" [ngClass]="viewFlag == 'All' ? 'selected': ''"
                    class="tabView stagebtn">All Projects</span>
            </div>
            <div *ngIf="path.length > 0 && viewFlag == 'All'" class="breadcrmb">
                <div (click)="goTofolder(item, i)" [ngClass]="i != path.length-1 ? 'point': '' "
                    *ngFor="let item of path;  let i = index">
                    <span *ngIf="item.Title != undefined" class="foldericon"><fa-icon
                            [icon]="faFolderOpen"></fa-icon></span><span> {{item.Title}} <span
                            *ngIf="i != path.length - 1">/</span> </span>
                </div>
            </div>
        </div>

        <!-- Modified by PP(2022-12-05) : Click twice - END -->
        <!-- <div class="sortby">
        <span class="label point" data-toggle="dropdown">Sort by [{{orderBytitle}}]</span>
        <span><fa-icon class="arrowIcon" (click)="changeOrder('Asc')" *ngIf="orderby == 'Dsc'" [icon]="faArrowUp"></fa-icon><fa-icon class="arrowIcon" (click)="changeOrder('Dsc')" *ngIf="orderby == 'Asc'" [icon]="faArrowDown"></fa-icon></span>
        <div class="dropdown-menu" id="sortby" aria-labelledby="sortby">
            <span class="dropdown-item" >Name</span>
            <span class="dropdown-item" >Date</span>
        </div>
    </div> -->

        <div class="nav-item dropdown sortby" ngbDropdown style="display:flex;">
            <!-- <a class="nav-link dropdown-toggle sortby" id="sortByDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle>
            {{displaySortByTitles}}
        </a>   -->
            <span class="point nav-link dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"
                ngbDropdownToggle>{{displaySortByTitles}}</span>
            <fa-icon class="arrowIcon" (click)="changeOrder('Asc')" *ngIf="orderby == 'Dsc'"
                [icon]="faArrowUp"></fa-icon><fa-icon class="arrowIcon" (click)="changeOrder('Dsc')"
                *ngIf="orderby == 'Asc'" [icon]="faArrowDown"></fa-icon>
            <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="navbarScrollingDropdown">
                <li ngbDropdownItem (click)="sort('name')"><a class="dropdown-item">Name</a></li>
                <li ngbDropdownItem (click)="sort('date')"><a class="dropdown-item">Date</a></li>
            </ul>

        </div>
        <!-- Modified by PP(2022-12-05) : Click twice - END -->

    </div>

    <div class="content">
        <div *ngIf='projects else noProjects' class="card-container">
            <div class="card ProjectCard" *ngFor="let item of projects; let j = index;">
                <label class="container" [ngClass]="fileSelected.indexOf(item.ID) > -1 ? 'displayImp':''">
                    <input class="check" *ngIf="item.Type == 'File'" type="checkbox">
                    <span class="checkmark"></span>
                </label>

                <!-- Modified by PP(2022-12-05) : Click twice - START -->
                <!-- <div class="verticalDropdown btn label" id="cardDrop" data-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false" (click)='showShow(j)'>
                <fa-icon [icon]="faEllipsisV"></fa-icon>
            </div>
            <div class="dropdown-menu" id="cardMore{{j}}" aria-labelledby="cardDrop">
                <span *ngIf="item.Type == 'File'" class="dropdown-item" (click)='editProject(item.ID)'>
                    <span class="icon"> <fa-icon [icon]="faPen"></fa-icon></span>
                Edit</span>
                <span data-toggle="modal" (click)="rename(item)" data-target="#rename" class="dropdown-item">
                    <span class="icon"> <fa-icon [icon]="faEdit"></fa-icon></span>
                Rename</span>
                <span *ngIf="item.Type == 'File'" class="dropdown-item" (click)="generateLink(item.ID)">
                    <span class="icon"><fa-icon [icon]="faShareAlt"></fa-icon></span>
                Share</span>
                <span class="dropdown-item red" *ngIf="item.Type == 'File'" (click)='deleteProject(item)'>
                    <span class="icon"><fa-icon [icon]="faTrash"></fa-icon></span>
                Delete</span>
                <span class="dropdown-item red" *ngIf="item.Type == 'Folder' && item.TotalFile===0" (click)='deleteProject(item)'>
                    <span class="icon"><fa-icon [icon]="faTrash"></fa-icon></span>
                Delete</span>
            </div> -->

                <div class="nav-item dropdown verticalDropdown" ngbDropdown>
                    <a class="nav-link dropdown-toggle verticalDropdown pad10" id="navbarScrollingDropdown"
                        role="button" data-bs-toggle="dropdown" aria-expanded="false" ngbDropdownToggle>
                        <fa-icon [icon]="faEllipsisV"></fa-icon>
                    </a>
                    <ul class="dropdown-menu" ngbDropdownMenu aria-labelledby="navbarScrollingDropdown">
                        <li ngbDropdownItem *ngIf="item.Type == 'File'"><a class="dropdown-item"
                                (click)='editProject(item.ID)'><fa-icon [icon]="faPen" class="pad10"></fa-icon>Open</a>
                        </li>
                        <li ngbDropdownItem><a class="dropdown-item" (click)="rename(item)" data-toggle="modal"
                                data-target="#rename"><fa-icon [icon]="faEdit" class="pad10"></fa-icon>Rename</a></li>
                        <li ngbDropdownItem *ngIf="item.Type == 'File'"><a class="dropdown-item"
                                (click)="generateLink(item.ID)"><fa-icon [icon]="faShareAlt"
                                    class="pad10"></fa-icon>Share</a></li>
                        <li ngbDropdownItem *ngIf="item.Type == 'File'"><a class="dropdown-item red"
                                (click)="deleteProject(item)"><fa-icon [icon]="faTrash"
                                    class="pad10"></fa-icon>Delete</a></li>
                        <li ngbDropdownItem *ngIf="item.Type == 'Folder' && item.TotalFile===0"><a
                                class="dropdown-item red" (click)="deleteProject(item)"><fa-icon [icon]="faTrash"
                                    class="pad10"></fa-icon>Delete</a></li>
                    </ul>
                </div>
                <!-- Modified by PP(2022-12-05) : Click twice - END -->

                <div (click)="openChild(item)" *ngIf="item.Type == 'Folder'" class="folderCard point">
                    <div class="folderImg">
                        <fa-icon [icon]="faFolderOpen"></fa-icon>
                    </div>
                    <div class="folderDetails">
                        <div class="card-title"> {{item.Fname}} </div>
                        <div class="card-desc">
                            <span>Created by: {{item.Name}} on {{item.newDate}}</span>
                        </div>
                        <div class="totalProj">
                            <span>{{item.TotalFile}} Project(s)</span>
                        </div>
                    </div>
                </div>
                <div (click)="editProject(item.ID)" *ngIf="item.Type == 'File'" class="folderCard point">
                    <div class="folderImg fileImgNoMargin">
                        <span class="imgContain"><img class="lowerImg" src="assets/images/file.png"><img class="fileImg"
                                src="assets/images/logo.png"></span>
                    </div>
                    <div class="folderDetails">
                        <div class="card-title"> {{item.Fname}} </div>
                        <div class="card-desc">
                            <span>{{item.Path}}</span>
                        </div>
                        <div class="card-desc">
                            <span>Created on {{item.newDate}}</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <ng-template #noProjects>
            <div class="noProjects">
                <div class="noProjectsRectangle">
                    <span class="mainTitle">NO PROJECTS</span>
                    <span class="desc">Just click on the New Project button to get started</span>
                </div>
            </div>
        </ng-template>
        <div *ngIf="projects !== undefined">
            <div *ngIf="projects.length == 0" class="noProjects">
                <div class="noProjectsRectangle">
                    <span class="mainTitle">NO FOLDER/FILE</span>
                    <span class="desc">Just click on the New Project button to get started</span>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="projects !== undefined">
        <div class="footer" [ngClass]="projects.length <= 3 ? 'alignBottom': ''">
            <div class="footimg"><span><img class="footerImage" src="assets/images/logo.png"></span> </div>
            <div class="footerbody">
                <span class="footerTitle">MCCLD Online</span>
                <span class="footerDesc">Powered by Camfil AB (3.0.0)</span>
                <span class="footerDesc">
                    © Camfil 1963–2025 |
                    <a href="https://www.camfil.com/en-my/privacy-policy" target="_blank" rel="noopener">
                    Privacy policy and Cookie information
                    </a>              
                </span>
            </div>
        </div>
    </div>
</div>

<ng-template #templateShare let-modal class="templateShare">
    <div class="modal-content" style="width:120%;">
        <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Share the project</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="initializeTeam(true)">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div>
                <div class="linkContent">
                    <input #linkT class="linkText" [value]="link" readonly>
                    <div class="button" (click)="copyLink2(link)">Copy Link &nbsp;
                        <!-- Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)-start -->
                        <fa-icon [icon]='faInfoCircle' class="info" id="CopyInfoBtn"
                            (mouseleave)="showHideInfoToggle('copy')"
                            (mouseenter)="showHideInfoToggle('copy')"></fa-icon>
                        <div id="CopyInfo">
                            <div class="InfoContent2">
                                You may copy the link directly to use at your convenience.
                            </div>
                            <div id="arrow" data-popper-arrow></div>
                        </div>
                        <!-- Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)-end -->
                    </div>
                </div>
            </div>
            <div class="seperator"><span>Invite Teammates</span></div>
        </div>
        <div class="row-1">
            <div class="flex-column-title">
                <div class="column-container">
                    <div class="column-content">
                        <div class="formgroup"> <label>Enter Full Name</label></div>
                    </div>
                </div>
                <div class="column-container">
                    <div class="column-content">
                        <div class="formgroup"> <label>Enter Email Id</label></div>
                    </div>
                </div>
            </div>
            <div class="flex-column">
                <div class="column-container">
                    <div class="column-content">
                        <div class="row" *ngFor="let t of team">
                            <div class="formgroup">
                                <input type="text" placeholder="Joe Don" class="input-field" [(ngModel)]="t.Name">
                            </div>
                            <div class="formgroup">
                                <input type="text" placeholder="you@example.com" class="input-field" name="email"
                                    [(ngModel)]="t.Email">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="addBtn" (click)="addRow()" *ngIf="team.length<10"><span>Add Teammate</span></div>
        </div>
        <!-- Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)-start -->
        <!-- <div class="next-button-content">
              <button class="button-content ripple" (click)='sendEmail()'>
                  <span class='space'>Send Invite</span>
              </button>
          </div> -->

        <div *ngIf="loading===false" class="next-button-content">
            <button class="button-content ripple" (click)='sendEmail()'>
                <span class='space'>Send Invite
                    <fa-icon [icon]='faInfoCircle' class="info" id="SendInfoBtn"
                        (mouseleave)="showHideInfoToggle('send')" (mouseenter)="showHideInfoToggle('send')"></fa-icon>
                    <div id="SendInfo">
                        <div class="InfoContent2">
                            The "Send Invite" will send an email containing an URL link with input data of the
                            project to the team mate(s). It will also send a copy to your mailbox as a reminder for
                            you.<Br>
                            The URL can be copied and pasted into the "Import project" function at the start page.
                        </div>
                        <div id="arrow" data-popper-arrow></div>
                    </div>
                </span>
            </button>
        </div>
        <div *ngIf="loading===true" class="next-button-content" style="width:35%;">
            <button class="button-content ripple" style="background:#F1F5F2;color:#00673E;width:200px;" disabled>
                <span class='space'>Email is being procesed</span>
            </button>
        </div>
        <!-- Modified by JW(2023-06-06):add info texts to SHARE project (follow CREO4 RNDS116 Log#59)-end -->
    </div>
</ng-template>

<div class="modal fade" id="export" tabindex="-1" role="dialog" aria-labelledby="export" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div *ngIf="exportMultipleProject" class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Export File(s)</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div>
                    <div class="linkContent">
                        <div>You are not allowed to export more than 1 project...</div>
                    </div>
                </div>
            </div>
            <div class="next-button-content">
                <button class="button-content ripple" data-dismiss="modal" aria-label="Close">
                    OK
                </button>
            </div>
        </div>

        <div *ngIf="!exportMultipleProject" class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Export File(s)</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div>
                    <div class="linkContent">
                        <div>Are you sure you want to export the selected file(s) ?</div>
                    </div>
                </div>
            </div>
            <div class="next-button-content flexend">
                <button class="button-content ripple btnNo" data-dismiss="modal" aria-label="Close">
                    No
                </button>
                <button class="button-content ripple" data-dismiss="modal" aria-label="Close">
                    Yes
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="rename" tabindex="-1" role="dialog" aria-labelledby="rename" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Rename {{ftype}}</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div>
                    <div class="linkContent">
                        <input type="text" [(ngModel)]="fname" class="fullwidth p10">
                    </div>
                </div>
            </div>
            <div class="next-button-content flexend">
                <button class="button-content ripple btnNo" data-dismiss="modal" aria-label="Close">
                    No
                </button>
                <button class="button-content ripple" (click)='RenameThis(fname, ftype, fid, fParentId)'
                    data-dismiss="modal" aria-label="Close">
                    Yes
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="newFolder" tabindex="-1" role="dialog" aria-labelledby="newFolder" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">New Folder</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div>
                    <div class="linkContent">
                        <input type="text" [(ngModel)]="newFolderName" class="fullwidth p10">
                    </div>
                </div>
            </div>
            <div class="next-button-content flexend">
                <button class="button-content ripple btnNo" data-dismiss="modal" aria-label="Close">
                    Cancel
                </button>
                <button class="button-content ripple" (click)='createFolder(newFolderName)' data-dismiss="modal"
                    aria-label="Close">
                    Create
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="upload" tabindex="-1" role="dialog" aria-labelledby="upload" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLongTitle">Import the project</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div>
                    <div class="uploadLinkContent">
                        <input #linkT class="linkText" placeholder="Enter your URL" [(ngModel)]="URL">
                    </div>
                </div>
                <div class="seperator"><span>OR</span></div>
                <div class="uploadArea" appDropFile (fileDropped)="onFileDropped($event)">
                    <div class="select" (click)="fileDropRef.click()">
                        <div><img src="assets/images/uploadIcon.png"></div>
                        <div><span class="title">Drop files here or click to <a><u>select files to upload</u></a></span>
                        </div>
                        <div><span class="desc">You can upload XML or zip only in file format.</span></div>
                        <input type="file" #fileDropRef id="fileDropRef"
                            (change)="onFileDropped($any($event.target).files)" />
                    </div>
                    <div class="files-list" *ngFor="let file of files;let i= index">
                        <span>{{ file }} </span>
                        <button class="delete-file" (click)="deleteAttachment(i)">
                            <fa-icon class="red" [icon]="faTrash"></fa-icon>
                        </button>
                    </div>
                </div>
            </div>
            <div class="btn-grp">
                <div id="divCancelImport" class="cancel" data-dismiss="modal">Cancel</div>
                <div class="next-button-content">
                    <button class="button-content ripple" (click)='import()'>
                        <span class='space'>Import</span>
                    </button>
                </div>
            </div>

        </div>
    </div>
</div>

<div class="d-flex justify-content-center cover-spin" *ngIf="loading">
    <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>